export default "__VITE_ASSET__BdSkmwHZ__"